import { createSelector } from 'reselect';

import { selectReportConfigurationHistory } from '../../common/history/selectors';
import { reportHistorySelector } from '../../common/history/state';
import { shareLinkSelector } from '../../common/modals/components/ShareModal/state';
import {
  selectCurrentReportConfiguration,
  selectReportConfigurationStatus
} from '../../common/reportConfiguration/selectors';
import { ReportConfigurationStatus } from '../../common/reportConfiguration/types';
import { selectCurrentSavedView } from '../../common/savedViews/selectors';

export const selectPreviousReportConfiguration = createSelector(reportHistorySelector, (reportHistory) => {
  if (reportHistory.history.length === 0) {
    return null;
  }

  if (reportHistory.history.length > 1) {
    const len = reportHistory.history.length;
    return reportHistory.history[len - 2];
  } else {
    return null;
  }
});

export const selectCurrentSavedViewModified = createSelector(
  selectReportConfigurationStatus,
  selectCurrentReportConfiguration,
  selectCurrentSavedView,
  (reportConfigStatus, currentReportConfiguration, currentSavedView) => {
    if (reportConfigStatus === ReportConfigurationStatus.Current && currentSavedView && currentReportConfiguration) {
      return currentReportConfiguration.id !== currentSavedView.reportConfiguration;
    }

    return false;
  }
);

export const selectIsSavedViewModifiedNoPermalink = createSelector(
  selectCurrentSavedViewModified,
  shareLinkSelector,
  selectCurrentReportConfiguration,
  (savedViewModified, shareLink, reportConfig) => {
    return (
      savedViewModified && (shareLink.snapshotLink === null || shareLink.snapshotLink === undefined) && !reportConfig.id
    );
  }
);

export const selectHistoryAndSavedView = createSelector(
  selectReportConfigurationHistory,
  selectCurrentSavedView,
  (history, savedView) => {
    return { history, savedView };
  }
);

export const selectReportConfigurationAndSavedView = createSelector(
  selectCurrentSavedView,
  selectCurrentReportConfiguration,
  (savedView, reportConfiguration) => {
    return { savedView, reportConfiguration };
  }
);

export const selectHistoryAndSavedViewAndReportConfiguration = createSelector(
  selectReportConfigurationHistory,
  selectCurrentSavedView,
  selectCurrentReportConfiguration,
  (history, savedView, reportConfiguration) => {
    return { history, savedView, reportConfiguration };
  }
);
